import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-side-menu-title',
  standalone: true,
  imports: [],
  templateUrl: './side-menu-title.component.html',
  styleUrl: './side-menu-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class SideMenuTitleComponent {}
